import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import ReferralFlow from 'components/Flows/ReferralFlows/ReferralFlows';
import ReferralAnalysisDrawer from 'components/Analyses/ReferralAnalyses/Drawer/Drawer';

const ReferralFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <ReferralAnalysisDrawer />
      <ReferralFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ReferralFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);